
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipWreckIec as ObiShipWreckIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-wreck-iec.js';
 
 
 

 
 export const ObiShipWreckIec = createComponent({
   react: React,
   tagName: 'obi-ship-wreck-iec',
   elementClass: ObiShipWreckIecElement,
   events: {
     
   }
  });
 
 